import "@snapchat/web-consumer-nav/dist/main.css";
import { Status, logWarning } from "@snapchat/web-log";
import { getLogger, logRequest } from "@snapchat/web-next-log";
import { ErrorWithStatus, fromAppPropsWithQueryLocale, fromError, fromIncomingPropsWithQueryLocale, isObject, tryParseJSON, updateResponseStatus, } from "@snapchat/web-proto-props";
import App from "next/app";
import { NotFound } from "../components/NotFound";
import { ContentUnavailable } from "../components/ContentUnavailable";
import { ensureRequestID, getRequestBody } from "../lib/requests";
import { setResponseHeaders } from "../lib/responses";
import "../styles/globals.css";
import { loadMessages } from "../i18n/messages";
function CustomApp(appProps) {
    switch (appProps.status) {
        case Status.Gone:
        case Status.Unavailable:
            return <ContentUnavailable />;
        case Status.NotFound:
        case Status.BadRequest:
            return <NotFound />;
        default:
            return <App {...appProps}/>;
    }
}
/* istanbul ignore next -- Ignore this as it's backend code only */
CustomApp.getInitialProps = async (appContext) => {
    const { req, res } = appContext.ctx;
    const requestID = req ? ensureRequestID(req) : "";
    setResponseHeaders(requestID, req, res);
    const log = getLogger(requestID, req);
    logRequest(req, res, appContext, log);
    // TODO: consider the pattern from https://hoangvvo.com/blog/nextjs-middleware
    const body = req?.readable ? await getRequestBody(req) : "";
    const incomingProps = body && tryParseJSON(body);
    if (isObject(incomingProps)) {
        return fromIncomingPropsWithQueryLocale(req, incomingProps, loadMessages);
    }
    else {
        try {
            const appProps = await App.getInitialProps(appContext);
            return await fromAppPropsWithQueryLocale(req, appProps, loadMessages);
        }
        catch (err) {
            if (err instanceof ErrorWithStatus) {
                logWarning(err, log);
                updateResponseStatus(res, err);
                return fromError(err);
            }
            else {
                throw err;
            }
        }
    }
};
export default CustomApp;
